import { style } from "d3";
import styled from "styled-components";

export const FilterChartContainer = styled.div`
    width : -webkit-fill-available;
    display: flex;
    // padding: 12px 8px 8px 8px;
    padding: 16px 8px;
    flex-direction: column;
    // align-items: flex-end;
    gap: 16px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid ${({theme})=>theme.playerDataBorder};
    background:${({theme})=> theme.playerContentBackground};

    .header{
        align-self: stretch;
        color: var(--Warm-Grey-warm-grey-600, #7C7D79);
        font-feature-settings: 'clig' off, 'liga' off;

        /* DM-Mono/Title/Small */
        font-family: "DM Mono";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 100% */
        text-transform: uppercase;
    }
`;
export const ToggleButtonContainer = styled.div`
    // display: flex;
    padding: 4px;
    align-items: flex-start;
    gap: 10px;
    border-radius: 99px;
    z-index: 0;
    // border: 1px solid var(--Warm-Grey-warm-grey-400, #C2C2C2);
    // background: var(--Warm-Grey-warm-grey-100, #F9FAF7);
`;

export const StatsValue = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    > div {
        flex: 1;
    }
    > input {
        flex: 1;
    }
`;